import React, { useState, useRef, useEffect } from 'react'
import axios from 'axios';
import Select from "react-select";
import Loader from "../../../comman/Loader";
import {baseUrl, purchaseProductList, milkType, labourType, productType} from "../../../comman/config";
import { useNavigate, Link } from 'react-router-dom';

export default function Form({detail}) {
    const today = new Date().toISOString().split("T")[0];
    const [formData, setFormData] = useState({
        date : today,
        category : '',
        type: '',
        company_id: '',
        product: '',
        installment_amount: '',
    });
    const [validationErrors, setValidationErrors] = useState({
        date: false,
        category: false,
        type: false,
        company_id : false,
        product : false,
        installment_amount: false,
    });
    const [popupOpen , setPopupOpen] = useState(false);
    const [staffList, setStaffList] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [productList, setProductList] = useState([]);
    const formRef = useRef(null);
    
    
    const navigate = useNavigate();

    useEffect(() => {
        getProductList();
    }, []);
    useEffect(() => {
        if(formData.category && formData.type){
            getCompanyList();
        }
    }, [formData.category, formData.type]);
    
    useEffect(() => {
        if(detail){
            const staffItem = staffList.find((item) => item.id == detail[0].staff_id);
            const staffObject = staffItem ? {value : staffItem.id, label : staffItem.name} : {value : "", label : ""};
            setFormData({
                date: detail[0].date || today,
                staff_id: staffObject,
                salary : detail[0].salary || 0,
                upaad : detail[0].upaad || '',
                due_salary: detail[0].due_salary || 0,
                db_id: detail[0]?.id ?? 0
            });
        }
    }, [detail, staffList]);


    const getCompanyList = async () => {
        setPopupOpen(true);
        console.log(formData.category);
        console.log(formData.type);
        const condition = `company_type = '${formData.category.value}' AND product_type  = '${formData.type.value}' AND status = 1`;        
        const response = await axios.get(`${baseUrl}/admin/profile/company/company_list?condition=${condition}`);
        setCompanyList(response.data.data);
        setPopupOpen(false);
    }
    const getProductList = async ()=> {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/profile/product/list_all`);
        setPopupOpen(false);
        setProductList(response.data.data);
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        const newValidationErrors = {
            date: formData.date === '',
            category : !formData.category.value,
            type : !formData.type.value,
            company_id : !formData.company_id.value,
            product : !formData.product.value,
            installment_amount : formData.installment_amount === '',
            
        };
        setValidationErrors(newValidationErrors);
        const hasErrors = Object.values(newValidationErrors).some((error) => error);
        if (hasErrors) {
            
            // Find the first invalid input element
            const firstInvalidInput = formRef.current.querySelector('.invalid');
            if (firstInvalidInput) {
              // Scroll to the first invalid input element
              firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }else {
            let url;
            try {
                setPopupOpen(true);
                if(detail){
                    url = `admin/account/edit/${detail[0].id}`;
                }else{
                    url = "admin/account/add";
                }
                console.log(url);
                await axios.post(`${baseUrl}/${url}`,{
                    formData: formData,
                });
                setPopupOpen(false);
                navigate("/admin/account/list");
            } catch (error) {

                setPopupOpen(false);
                console.log(error);
                
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
    
            }));
      
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false
        }));
    };

    const handleSelectChange = (data, option) => {
        if(option.name === "category"){
            setFormData((prevData) => ({
                ...prevData,
                [option.name]: data,
                "type": "",
                "company_id" :"",
                "product" :"",             
                "installment_amount" : ""
              }));
              
        }else if(option.name === "type"){
            setFormData((prevData) => ({
                ...prevData,
                [option.name]: data,                
                "company_id" :"",
                "product" :"",             
                "installment_amount" : ""
              }));
              
        }else{
            setFormData((prevData) => ({
                ...prevData,
                [option.name]: data,
            }));
        }
        
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [option.name]: false,
        }));
      };
    

  return (
 
 <form ref={formRef}>
    {popupOpen && (
                     <Loader /> 
                ) }
                <div className="space-y-12">
                    <div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="date" className="block text-sm font-medium leading-6 text-gray-900">Date</label>
                                <div className="mt-2">
                                <input
                                    type="date"
                                    name="date"
                                    id="date"
                                    value={formData.date}
                                    onChange={handleInputChange}
                                    className={`block w-full rounded-md border ${
                                        validationErrors.date ? "border-red-500" : "border-gray-300"
                                    } py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                />
                                </div>
                                {validationErrors.date && <div className="text-red-500">Please enter a date.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="category" className="block text-sm font-medium leading-6 text-gray-900">Category</label>
                                <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.category}
                                        name="category"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={labourType.map((item) => ({
                                            value: item.value,
                                            label: item.label,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                                {validationErrors.category && <div className="text-red-500">Please select a category.</div>}
                            </div>
                        </div>
                       
                       <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                       {formData.category && <div className="sm:col-span-2">
                                <label htmlFor="type" className="block text-sm font-medium leading-6 text-gray-900">Type</label>
                                <div className="mt-2">
                                    
                                <Select
                                        classNamePrefix="select"
                                        value={formData.type}
                                        name="type"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={productType.filter((item) => item.company_type == formData.category.value).map((item) => ({
                                            value: item.value,
                                            label: item.label,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                    
                                </div>
                                {validationErrors.type && <div className="text-red-500">Please select type.</div>}
                            </div>}
                            {formData.type && <div className="sm:col-span-2">
                                <label htmlFor="company_id" className="block text-sm font-medium leading-6 text-gray-900">Company</label>
                                <div className="mt-2">
                                    
                                <Select
                                        classNamePrefix="select"
                                        value={formData.company_id}
                                        name="company_id"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={companyList.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                    
                                </div>
                                {validationErrors.company_id && <div className="text-red-500">Please select company.</div>}
                            </div>}
                            
                         
                        </div>

                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                        {formData.company_id && <div className="sm:col-span-2">
                                <label htmlFor="product" className="block text-sm font-medium leading-6 text-gray-900">Product</label>
                                <div className="mt-2">
                                    
                                <Select
                                        classNamePrefix="select"
                                        value={formData.product}
                                        name="product"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={productList.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                    
                                </div>
                                {validationErrors.product && <div className="text-red-500">Please select product.</div>}
                            </div>}
                            {formData.company_id && <div className="sm:col-span-2">
                                <label htmlFor="installment_amount" className="block text-sm font-medium leading-6 text-gray-900">Installment Amount</label>
                                <div className="mt-2">
                                    
                                <input 
                                      id="installment_amount"
                                      name="installment_amount"
                                      type="number"
                                      step="0.01"
                                      placeholder='Installment Amount'
                                      value={formData.installment_amount}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.installment_amount ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                    
                                </div>
                                {validationErrors.installment_amount && <div className="text-red-500">Please enter amount.</div>}
                            </div>}
                        </div>
                    </div>
                </div>
                <div className="mt-6 flex items-center justify-end gap-x-6">
                    <Link to="/admin/account/list">
                        <button type="button" className="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
                    </Link>
                    <button
                    onClick={handleSubmit}
                      type="submit"
                      className="rounded-md bg-blue-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Save
                    </button>
                </div>
            </form>
            )
        }